import { combineReducers } from 'redux';
import { RootAction } from '@src/app/_redux';
import {
  STOPCHARGE_LOADING,
  STOPCHARGE_ERROR,
  STOPCHARGE_START,
  STOPCHARGE_SUCCESS,
  STOPCHARGE_CANCEL,
} from '@src/app/accounts/stopcharge/actions';
import { OMS_LOOKUP_SUCCESS } from '@src/app/login/oms/actions';
export type State = {
  readonly loading: boolean;
  stopChargeResult: Object | null;
};

export const reducer = combineReducers<State, RootAction>({
  loading: (state = false, action) => {
    switch (action.type) {
      case STOPCHARGE_ERROR:
      case STOPCHARGE_START:
      case OMS_LOOKUP_SUCCESS:
        return false;
      case STOPCHARGE_LOADING:
        return action.payload;
      default:
        return state;
    }
  },

  stopChargeResult: (state = null, action) => {
    switch (action.type) {
      case STOPCHARGE_SUCCESS:
      case STOPCHARGE_ERROR:
        return action.payload;
      case STOPCHARGE_CANCEL:
      case STOPCHARGE_START:
        return null;
      default:
        return state;
    }
  },
});
